// src/redux/actions/actionTypes.js
export const SET_VIDEOS = "SET_VIDEOS";
export const SELECT_VIDEO = "SELECT_VIDEO";
export const ADD_VIDEO = "ADD_VIDEO"; // New action type
